module.exports = __webpack_public_path__ + "static/media/shop-category-trailer.0ae7465f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/shop-category-trailer.svg
// module id = 932
// module chunks = 0